import $ from 'wee-dom';
import $events from 'wee-events';
import { RouteHandler } from 'wee-routes';


function tweetableBlock() {
	let twits = $('.js-tweetable');

	twits.each().addClass('help');
}

export default new RouteHandler({
	// TODO: All of this
	init() {
		tweetableBlock();
	}
});